/* Bulivia: Gratis-Geschenke im Warenkorb */
(function () {
  'use strict';

  if (window.__bvGeschenke) return;
  window.__bvGeschenke = true;

  var AUSLOESER = [58355911131480, 58355911164248, 58355911197016];
  var GESCHENKE = [58449406722392, 58449258185048];

  var MARKE = '_geschenk';
  var MARKE_WERT = 'Gratis Geschenk';

  var TITEL = '2 Gratis-Geschenke inklusive';
  var ZEILE = 'Gua Sha und Gesichtsroller sind schon dabei, ohne Aufpreis.';

  var laeuft = false;
  var zeigeHinweis = false;

  var ZIELE = [
    { id: 'cart-drawer',      quelle: '#CartDrawer',      ziel: '#CartDrawer' },
    { id: 'cart-icon-bubble', quelle: '.shopify-section', ziel: '#cart-icon-bubble' },
    { id: 'main-cart-items',  quelle: '.js-contents',     ziel: '#main-cart-items .js-contents' },
    { id: 'main-cart-footer', quelle: '.js-contents',     ziel: '#main-cart-footer .js-contents' }
  ];

  function wurzel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartHolen() {
    return fetch(wurzel() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function senden(pfad, daten) {
    return fetch(wurzel() + pfad, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(daten)
    });
  }

  function hatAusloeser(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (AUSLOESER.indexOf(cart.items[i].variant_id) !== -1) return true;
    }
    return false;
  }

  function geschenkZeile(cart, id) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id === id && it.properties && it.properties[MARKE] === MARKE_WERT) return it;
    }
    return null;
  }

  function stilEinfuegen() {
    if (document.getElementById('bv-geschenk-stil')) return;
    var s = document.createElement('style');
    s.id = 'bv-geschenk-stil';
    s.textContent =
      '.bv-geschenk{display:flex;align-items:flex-start;gap:10px;' +
      'padding:12px 14px;margin:0 0 1.5rem;background:#f4ecfa;' +
      'border:1px solid #e3d2f0;border-radius:10px;}' +
      '.bv-geschenk__icon{flex:0 0 auto;line-height:0;margin-top:1px;}' +
      '.bv-geschenk__text{min-width:0;}' +
      '.bv-geschenk__titel{margin:0 0 2px;font-size:1.4rem;font-weight:600;' +
      'line-height:1.3;color:#2a1f30;letter-spacing:0;}' +
      '.bv-geschenk__zeile{margin:0;font-size:1.25rem;line-height:1.4;' +
      'color:#5a4a63;letter-spacing:0;}';
    document.head.appendChild(s);
  }

  function hinweisBauen() {
    var box = document.createElement('div');
    box.className = 'bv-geschenk';
    box.innerHTML =
      '<span class="bv-geschenk__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 20 20" width="18" height="18" fill="none">' +
          '<circle cx="10" cy="10" r="10" fill="#8b5ab8"></circle>' +
          '<path d="M6 10.2l2.6 2.6L14 7.4" stroke="#ffffff" stroke-width="2" ' +
          'stroke-linecap="round" stroke-linejoin="round"></path>' +
        '</svg>' +
      '</span>' +
      '<div class="bv-geschenk__text">' +
        '<p class="bv-geschenk__titel"></p>' +
        '<p class="bv-geschenk__zeile"></p>' +
      '</div>';
    box.querySelector('.bv-geschenk__titel').textContent = TITEL;
    box.querySelector('.bv-geschenk__zeile').textContent = ZEILE;
    return box;
  }

  function hinweisSetzen() {
    var behaelter = document.querySelectorAll('#CartDrawer, #main-cart-items');
    Array.prototype.forEach.call(behaelter, function (wrap) {
      var vorhanden = wrap.querySelector('.bv-geschenk');

      if (!zeigeHinweis) {
        if (vorhanden && vorhanden.parentNode) vorhanden.parentNode.removeChild(vorhanden);
        return;
      }
      if (vorhanden) return;

      var anker = wrap.querySelector('.drawer__header') || wrap.querySelector('.title-wrapper-with-link');
      if (!anker) return;

      stilEinfuegen();
      if (anker.nextSibling) {
        anker.parentNode.insertBefore(hinweisBauen(), anker.nextSibling);
      } else {
        anker.parentNode.appendChild(hinweisBauen());
      }
    });
  }

  function sortieren() {
    var koerper = document.querySelectorAll('#CartDrawer tbody, #main-cart-items tbody');
    Array.prototype.forEach.call(koerper, function (tb) {
      var reihen = Array.prototype.slice.call(tb.querySelectorAll('tr.cart-item'));
      if (reihen.length < 2) return;

      var geschenke = [];
      var normale = [];

      reihen.forEach(function (tr) {
        var feld = tr.querySelector('[data-quantity-variant-id]');
        var vid = feld ? parseInt(feld.getAttribute('data-quantity-variant-id'), 10) : 0;
        if (GESCHENKE.indexOf(vid) !== -1) {
          geschenke.push(tr);
        } else {
          normale.push(tr);
        }
      });

      if (!geschenke.length || !normale.length) return;

      var letzteNormale = reihen.indexOf(normale[normale.length - 1]);
      var erstesGeschenk = reihen.indexOf(geschenke[0]);
      if (letzteNormale < erstesGeschenk) return;

      geschenke.forEach(function (tr) { tb.appendChild(tr); });
    });
  }

  function aufraeumen() {
    hinweisSetzen();
    sortieren();
  }

  function beobachten() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.dataset.bvBeobachtet === '1') return;
    drawer.dataset.bvBeobachtet = '1';
    new MutationObserver(function () { aufraeumen(); })
      .observe(drawer, { childList: true, subtree: true });
  }

  function abgleichen() {
    if (laeuft) return Promise.resolve(false);
    laeuft = true;

    return cartHolen().then(function (cart) {
      var soll = hatAusloeser(cart);
      zeigeHinweis = soll;

      var updates = {};
      var neu = [];
      var geaendert = false;

      GESCHENKE.forEach(function (gid) {
        var zeile = geschenkZeile(cart, gid);
        if (soll) {
          if (!zeile) {
            var props = {};
            props[MARKE] = MARKE_WERT;
            neu.push({ id: gid, quantity: 1, properties: props });
            geaendert = true;
          } else if (zeile.quantity !== 1) {
            updates[zeile.key] = 1;
            geaendert = true;
          }
        } else if (zeile) {
          updates[zeile.key] = 0;
          geaendert = true;
        }
      });

      if (!geaendert) return false;

      var kette = Promise.resolve();
      if (Object.keys(updates).length) {
        kette = kette.then(function () { return senden('cart/update.js', { updates: updates }); });
      }
      if (neu.length) {
        kette = kette.then(function () { return senden('cart/add.js', { items: neu }); });
      }
      return kette.then(function () { return true; });
    }).catch(function () {
      return false;
    }).then(function (erg) {
      laeuft = false;
      return erg;
    });
  }

  function neuZeichnen() {
    var aktive = ZIELE.filter(function (z) { return document.querySelector(z.ziel); });
    if (!aktive.length) return Promise.resolve();
    var ids = aktive.map(function (z) { return z.id; }).join(',');

    return fetch(wurzel() + '?sections=' + ids, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (daten) {
        aktive.forEach(function (z) {
          if (!daten[z.id]) return;
          var doc = new DOMParser().parseFromString(daten[z.id], 'text/html');
          var q = doc.querySelector(z.quelle);
          var t = document.querySelector(z.ziel);
          if (q && t) t.innerHTML = q.innerHTML;
        });
      })
      .catch(function () {});
  }

  function pruefen() {
    abgleichen().then(function (geaendert) {
      if (geaendert) {
        neuZeichnen().then(function () { aufraeumen(); });
      } else {
        aufraeumen();
      }
    });
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = '';
    try {
      url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    } catch (e) {}

    var istWarenkorb = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
    var antwort = originalFetch.apply(this, args);

    if (!istWarenkorb || laeuft) return antwort;

    return antwort.then(function (res) {
      setTimeout(pruefen, 0);
      return res;
    });
  };

  function start() {
    beobachten();
    pruefen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();